import script from "./LogoutDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutDialog.vue?vue&type=script&setup=true&lang=js"

import "./LogoutDialog.vue?vue&type=style&index=0&id=be388706&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be388706"]])

export default __exports__